import { NavLink, useNavigate } from 'react-router-dom';
import { Menu, Container, Image, Button } from 'semantic-ui-react';
import { useQuery } from '@tanstack/react-query';
import { getConfiguration } from '../lib/configuration';
import { useAuthStore } from '../lib/authStore';
import { buildPath } from '../lib/tenant';
import { t } from '../locales';

export function Header() {
    const navigate = useNavigate();
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const logout = useAuthStore((s) => s.logout);

    const configQuery = useQuery({
        queryKey: ['configuration'],
        queryFn: getConfiguration,
        staleTime: 60 * 60 * 1000,
    });

    const logo = configQuery.data?.logo ?? '';

    const handleLogout = async () => {
        await logout();
        navigate(buildPath('/events'));
    };

    return (
        <Menu fixed="top" style={{ backgroundColor: 'var(--colour_menu_main)', minHeight: 50 }}>
            <Container>
                <Menu.Item as={NavLink} to={buildPath('/events')} header>
                    {logo
                        ? <Image src={logo} className="headerImage" />
                        : <span style={{ color: '#fff', fontWeight: 700, fontSize: '1.1rem' }}>{t('header.brandFallback')}</span>
                    }
                </Menu.Item>

                {configQuery.data?.capabilities?.feature_conference_planning !== false && (
                    <Menu.Item
                        as={NavLink}
                        to={buildPath('/conferences')}
                        style={{ color: '#fff' }}
                    >
                        {t('header.conferences')}
                    </Menu.Item>
                )}

                <Menu.Item
                    as={NavLink}
                    to={buildPath('/organiser')}
                    style={{ color: '#fff' }}
                >
                    {t('header.about')}
                </Menu.Item>

                <Menu.Menu position="right">
                    {isAuthenticated ? (
                        <>
                            <Menu.Item
                                as={NavLink}
                                to={buildPath('/my-tickets')}
                                style={{ color: '#fff' }}
                            >
                                {t('header.myTickets')}
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to={buildPath('/profile')}
                                style={{ color: '#fff' }}
                            >
                                {t('header.profile')}
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to={buildPath('/memberships')}
                                style={{ color: '#fff' }}
                            >
                                {t('header.memberships')}
                            </Menu.Item>
                            <Menu.Item>
                                <Button size="small" basic inverted onClick={handleLogout}>
                                    {t('header.signOut')}
                                </Button>
                            </Menu.Item>
                        </>
                    ) : (
                        <>
                            <Menu.Item
                                as={NavLink}
                                to={buildPath('/login')}
                                style={{ color: '#fff' }}
                            >
                                {t('header.signIn')}
                            </Menu.Item>
                            <Menu.Item>
                                <Button
                                    size="small"
                                    primary
                                    as={NavLink}
                                    to={buildPath('/register')}
                                    style={{ backgroundColor: 'var(--colour_heading_success)', color: '#fff', border: 'none' }}
                                >
                                    {t('header.register')}
                                </Button>
                            </Menu.Item>
                        </>
                    )}
                </Menu.Menu>
            </Container>
        </Menu>
    );
}

export default Header;
